import styled from 'styled-components';
import { Tooltip, Box, Stack } from '@mui/material';

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;

  strong {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
`;

export const LabelFileInput = styled.label`
  height: 36.5px;
  padding: 6px 16px;
  background-color: #fff;
  color: #e38500;
  font-size: 15px;
  border-radius: 4px;
  border: 1px solid rgba(227, 133, 0, 0.5);
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: background-color 0.2s, border-color 0.2s;

  &:hover {
    background-color: #fefaf5;
    border: 1px solid #e38500;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px;
  border-radius: 50%;
  background: transparent;
  border: none;
  outline: none;

  svg {
    color: #004e9a;
    transition: color 0.2s;
  }

  &:hover {
    svg {
      color: #00366b;
    }
  }
`;

export const Title = styled.p`
  font-weight: bold;
  margin-bottom: 16px;
`;

export const ContainerBtnDocument = styled(Stack)`
  width: 100%;
  align-items: flex-start;

  .btnDocument {
    @media (max-width: 768px) {
      // width: 100%;
      flex: 1;
      justify-content: center !important;
    }
  }
`;

export const ContainerDocument = styled(Stack)`
  width: 100%;

  .containerDocumentResponsive {
    width: 460px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: -10px;
    padding-left: 5px;

    @media (max-width: 768px) {
      // flex-direction: column;
      // justify-content: flex-start;
      margin-bottom: 10px;
      width: 100% !important;
    }
  }

  .documentResponsive {
    @media (max-width: 768px) {
      display: flex;
      flex-direction: row;
      margin-top: -10px;
    }
  }

  .fileNameResponsive {
    @media (max-width: 480px) {
      width: 140px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
`;
